export class SamePasswordError extends Error {
  constructor () {
    super('Senha e nova senha são iguais, por favor informe uma nova senha diferente da atual!')
    this.name = 'SamePasswordError'
  }
}
